module.exports = __webpack_public_path__ + "static/media/dropout_formula.d5927e56.png";